<template>
  <div id="head-nav" :style="{ top }" v-ceiling-lamp>
    <!-- logo -->
    <div class="nav-logo">
      <a href="/#/home">
        <img src="../../assets/logo.jpg" alt="" />
      </a>
    </div>
    <!-- navbar -->
    <ul class="nav-links">
      <li v-for="(item, index) in navList" :key="index">
        <router-link :to="item.path" class="nav-link" active-class="active">{{
          item.label
        }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { PRODUCT_NAME } from "@/common/constant.js";

export default {
  name: "Header",
  data() {
    return {
      navList: [
        {
          label: "首页",
          path: "/home",
        },
        {
          label: PRODUCT_NAME.PHOTO_HOME,
          path: "/xc",
        },
        {
          label: PRODUCT_NAME.FRAME,
          path: "/xk",
        },
        // {
        //   label: PRODUCT_NAME.HARD_FRAME,
        //   path: '/ypxk'
        // },
        {
          label: "下载App",
          path: this.$global.isHuaqi ? "/huaqidownload" : "/download",
        },
        {
          label: "关于我们",
          path: "/about",
        },
      ],
      // headerStyle: {top: 0},
      top: "0px",
      resizeHander: null,
      wheelHander: null,
      debounce: null,
      headerHeight: 0,
      scrollDirection: "",
      scrollActionY: null,
    };
  },
  directives: {
    "ceiling-lamp": {
      // 绑定 (当被绑定的元素插入到 DOM 中时……，在mounted之前，created之后)
      bind(el, binding, { context: _this }, oldNode) {
        window.addEventListener(
          "resize",
          (_this.resizeHander = () => {
            _this.setHeaderTop(0);
            clearTimeout(_this.debounce);
            _this.debounce = setTimeout(() => {
              _this.headerHeight = el.offsetHeight;
            }, 300);
          }),
        );
        window.addEventListener(
          "scroll",
          (_this.wheelHander = () => {
            _this.setCeilingLamp();
          }),
        );
      },
      // 初始化
      inserted(el, binding, vnode, oldNode) {
        let { context: _this } = vnode;
        _this.headerHeight = el.offsetHeight;
      },
      // 解绑，销毁时触发
      unbind(el, binding, vnode, oldNode) {
        let { context: _this } = vnode;
        window.removeEventListener("resize", _this.resizeHander);
        window.removeEventListener("scroll", _this.wheelHander);
      },
    },
  },
  methods: {
    setHeaderTop(top) {
      this.top = top + "px";
    },
    // 根据滚轮方向设置Header的显隐
    setCeilingLamp() {
      if (this.scrollActionY === null) {
        this.scrollActionY = window.pageYOffset;
      }
      let diffY = this.scrollActionY - window.pageYOffset;
      if (diffY < 0 && window.pageYOffset > 100) {
        // 页面向下滚动
        this.setHeaderTop(-this.headerHeight);
      } else {
        // 页面向上滚动
        if (!this._clickNavScrolling) {
          // 非点击侧边导航栏触发的滚动
          this.setHeaderTop(0);
        }
      }
      this.scrollActionY = window.pageYOffset;
    },
  },
  mounted() {
    // 点击导航条跳转时，隐藏顶部Header
    this.$bus.$on("hideHeader", () => {
      // 隐藏Header
      this.setHeaderTop(-this.headerHeight);
    });
    this.$bus.$on("showHeader", () => {
      // 显示顶部Header
      this.setHeaderTop(0);
    });
  },
  destroy() {
    this.$bus.$off("hideHeader", "showHeader");
  },
};
</script>

<style lang="scss" scoped>
#head-nav {
  position: fixed;
  left: 0;
  right: 0;
  height: var(--head-height);
  line-height: var(--head-height);
  z-index: 99;
  box-shadow: inset 0 1px 3px 1px #eee;
  background-color: #fff;
  transition: all 0.3s;
  .nav-logo {
    position: absolute;
    left: 5%;
    top: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 3vw;
      vertical-align: middle;
    }
  }
  .nav-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 60%;
    margin: 0 auto;
    li {
      height: 100%;
      .nav-link {
        display: inline-block;
        line-height: 100%;
        font-size: 2rem;
        font-weight: 600;
        letter-spacing: 0.1rem;
        color: #777;
        text-decoration: none;
        padding: 1rem 0.5rem;
        &.active {
          // transform: scale(1.2);
          color: var(--theme-color);
          border-bottom: 2px solid var(--theme-color);
        }
      }
    }
  }
}
@media (max-width: 768px) {
  #head-nav {
    .nav-logo {
      left: 7vw;
      img {
        width: 6vw;
      }
    }
    .nav-links {
      margin-left: 12vw;
      width: 85vw !important;
      justify-content: space-around;
      li {
        .nav-link {
          font-size: 5rem !important;
          vertical-align: middle;
          padding: 2rem 0;
          &.active {
            // transform: scale(1);
            border-bottom: 1px solid var(--theme-color) !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue